import React, { type ReactNode } from 'react';
import Breadcrumb from '@atlassian/jira-breadcrumbs/src/breadcrumb';
import { ff } from '@atlassian/jira-feature-flagging';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

type Props = {
	projectKey: string | undefined;
	children: ReactNode;
};

export const KnowledgeBaseBreadcrumb = ({ projectKey, children }: Props) => {
	const { formatMessage } = useIntl();
	const constructHref = () =>
		ff('jsm-kb-nav-refresh-changes-enabled') && window.location.href.includes('/categories')
			? `/jira/servicedesk/projects/${projectKey}/knowledge/categories`
			: `/jira/servicedesk/projects/${projectKey}/knowledge`;

	return (
		<Breadcrumb
			breadcrumb={{
				href: constructHref(),
				text: formatMessage(messages.knowledgeBase),
				type: 'jsd-knowledge-base',
			}}
		>
			{children}
		</Breadcrumb>
	);
};

export default KnowledgeBaseBreadcrumb;
